<template>
  <div class="add-box">
    <UploadDicom ref="UploadDicom" :uploadInfo="uploadInfo" @uploadres="uploadres" />
    <TableLayout>
      <template slot="table-wrap">
        <el-table
          ref="tableList"
          :header-cell-style="{background:'#1e87f1', color:'#fff'}" :height="550"
          v-loading="isWorking.loading"
          :data="tableData.list" fixed
        >
          <el-table-column prop="accessNo" label="检查编号" min-width="150px" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" min-width="100px" align="center"></el-table-column>
          <el-table-column label="操作" width="200px" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" @click="previewDimage(row)">预览</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="fix-footer">
          <pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange($event, { msg: true })"
            :pagination="tableData.pagination"
          ></pagination>
        </div>
      </template>  
    </TableLayout>
  </div>
</template>

<script>
import TableLayout from '@/layout/TableLayout'
import BaseTable from '@/components/BaseTable'
import Pagination from '@/components/common/pagination'
import UploadDicom from '@/components/UploadDicom';
import { fileServer } from '@/api/api'
export default {
  components: {TableLayout, Pagination, UploadDicom},
  extends: BaseTable,
  data () {
    return {
      uploadInfo: {
        tip: '支持上传.zip的原始影像压缩包，不超过1G;或多个后缀为.dcm的原始影像文件，单个影像不得超过10M',
        accept: '.zip,.dcm',
        multiple: true,
        fileList: [],
        fileSize: 1000,
        show: false,
      },
      formData: {}
    }
  },
  methods: {
    /**
     * 页码变更处理
     * @function handlePageChange
     * @param { Interger } pageIndex 搜索页面
     * @param { Object } obj 搜索处理逻辑内容
     */
    handlePageChange (pageIndex, obj = {}) {
      this.isWorking.loading = true
      this.tableData.pagination.pageIndex = pageIndex
      fileServer.getcheckData({
        page: pageIndex,
        rows: this.tableData.pagination.pageSize
      }).then(res => {
        this.isWorking.loading = false
        let { code, data, message } = res
        if (code === '0') {
          if (data) {
            this.tableData.list = data.records
            this.tableData.pagination.total = data.total || 0
          }
        } else {
          this.$message.error(message)
        }
      }).finally(() => {
        this.isWorking.loading = false
      })
    },
    previewDimage (row) {
      window.open(this.$dimage + row.url, '_blank')
    },
    uploadres (res) {
      this.handlePageChange(1)
      this.$emit('close')
    //   this.formData.filePath = res.response ? res.response.data.fileKey : null
    //   this.formData.originalFile = res.file ? res.file.name : null
    },
  }
}
</script>

<style scoped lang='scss'>
.add-box {
  text-align: left;
}
.el-dialog__body {
  padding-bottom: 12px;
}
.add-box .table-content .table-wrap {
  box-shadow: none !important;
}
</style>


// WEBPACK FOOTER //
// src/views/resource/page/UploadDicom.vue